<template>
  <div v-if="badges.length" class="absolute right-0 flex flex-row items-end badge">
    <CampaignBadge
      v-for="badge in badges"
      :key="badge.title"
      :class="badgeClass"
      :title="badge.title"
      :icon="badge.icon"
      :is-assortment="badge.isAssortment"
      :template="badge.template"
      :slug="badge.slug"
    />
  </div>
</template>

<script setup lang="ts">
import type { CampaignBadge } from '~/types/campaign';

type Props = {
  badges?: CampaignBadge[];
  badgeClass?: string;
};

withDefaults(defineProps<Props>(), {
  badges: () => [],
  badgeClass: '',
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'CampaignBadges',
});
</script>

<style lang="scss" scoped>
$medium: 600px;
.badge {
  flex-wrap: nowrap;
  @container (max-width: #{$medium}) {
    flex-wrap: wrap;
  }
}
</style>
